/*
 * @Author: liguokang
 * @Date: 2021-08-04 13:50:59
 * @LastEditors: liuxiaoyan
 * @LastEditTime: 2021-09-07 10:20:21
 * @Description:
 * @Copyrigh: ©2021 杭州杰竞科技有限公司 版权所有
 */

import React, { useEffect, useState, useImperativeHandle } from 'react';
import { Modal } from 'antd';

// 此文件B端人脸考勤部分同有使用，注意同步更改
const LayerPaperPage = React.forwardRef((props, ref) => {
  const [visible, setVisible] = useState(false);
  useImperativeHandle(ref, () => ({
    ...props,
    visible,
    pageShow: pageShow
  }));
  useEffect(() => {
    let isShow = localStorage.getItem('layer_notice_paper');
    if (isShow == 'true') {
      setVisible(false);
    } else {
      setVisible(true);
    }
  }, []);

  const handleOk = e => {
    localStorage.setItem('layer_notice_paper', true);
    setVisible(false);
  };
  const pageShow = e => {
    localStorage.setItem('layer_notice_paper', false);
    setVisible(true);
  };

  return (
    <Modal
      width={680}
      title={`人脸采集告知书`}
      footer={null}
      closable={false}
      maskClosable={false}
      cancelText=''
      okText='我知道了'
      className='layer_parper_modal'
      visible={visible}
      onOk={handleOk}
      onCancel={handleOk}>
      <div className='layer_paperpage'>
        <div className='layer_paperpage_content'>
          <h2>人脸考勤服务告知书</h2>
          {/* 使用wangEdit编辑 */}
          <div style={{ textAlign: 'justify' }} className='text_part'>
            &nbsp;&nbsp;&nbsp;&nbsp;人脸考勤服务告知书欢迎您使用”人脸考勤服务”(以下统称”人脸考勤服务”或"本服务”)。本告知书将杭州杰竞科技有限公司简称为“小麦助教"，对使用小麦助教服务的用户简称为"您”或"小麦助教用户”或"用户”。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;小麦助教提醒您，在您开始使用人脸考勤服务前，请您认真阅读、充分理解本告知书各条款，尤其是(可能)免除或限制小麦助教责任的条款(上述限制、免责条款可能以加粗形式提醒您注意)。一旦您使用人脸考勤服务，即表示您同意遵循本协议的所有约定。
            <br />
            如果您未满18周岁，请在法定监护人的陪同下阅读本协议，并在使用本服务前取得所有必要的监护人明确同意。保护用户个人信息是小麦助教的一项基本原则。小麦助教将按照本协议收集、使用、储存您的个人信息。
            <br />
            <h4>一、定义</h4>&nbsp;&nbsp;&nbsp;&nbsp;人脸考勤：指由小麦助教开发的、搭载于手机及其他设备的一种基于面部识别的身份认证技术。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;人脸考勤信息采集服务：指教培机构开通人脸考勤功能后，在小麦助教家长端账户登录的状态下，用户通过手机录入学员人脸信息；或通过培训机构账号发起的人脸采集二维码，完成人脸信息的采集服务。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;人脸考勤识别：指培训机构在小麦助教账户登录的状态下，通过电脑等硬件进行人脸验证即可享受的考勤服务。
            <br />
            二、硬件说明
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;用户可通过小麦助教人脸考勤硬件设备（也可选用自有设备，如平板、摄像头等），硬件设备售后服务说明如下：
            <br />
            &nbsp; &nbsp; 1. 从用户收货日起，7天内，若硬件设备出现质量问题，由用户将设备寄回厂家更换新设备；
            <br />
            &nbsp; &nbsp; 2.从用户收货日起，一年内，若硬件设备出现质量问题，软件方面问题由技术人员直接远程进行维修，硬件方面问题，则由用户寄回厂家进行维修；
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;3.硬件购买过程中硬件方仅提供一次免邮服务。
            <br />
            <h4>二、双方权利义务</h4>
            &nbsp;&nbsp;&nbsp;&nbsp;1、人脸考勤由您录入具备人脸特征识别功能的手机、人脸考勤硬件设备、百度人脸识别系统以及小麦助教人脸考勤系统完成，并由该手机硬件、人脸考勤硬件设备及小麦助教人脸考勤系统保存您的人脸特征；您了解并同意，小麦助教收集并存储您的人脸特征数据，否则您无法使用我们的人脸考勤服务。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;2、小麦助教十分重视用户信息的保护，小麦助教将会采取合理措施保护您的隐私权。为了向您提供更好的服务，您同意并授权小麦助教基于服务必要性获取相应的信息和数据，不论是您主动提供的还是使用本服务过程中小麦助教获取的信息和数据。小麦助教获取信息和数据将用于改善小麦助教的服务，向您提供更好的用户体验以及满足您的需求等。同时，小麦助教保证会单独、加密存储您的人脸特征数据。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;3、如果您不同意提供相关信息和数据，您将无法使用本服务。一旦您选择使用本服务，即表示您认可并接受本协议。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;4、您在开通本服务后，通过您在手机或其他设备中上传的人脸特征，向小麦助教发出的指令，将不可撤回或撤销，且成为小麦助教执行您考勤或进行其他操作的唯一指令；请您注意保管好手机及其他人脸考勤硬件设备，避免他人在您的手机或其他人脸考勤硬件设备中存入其人脸特征使您遭受损失，您应当对小麦助教执行您通过人脸考勤而向小麦助教发出的指令所产生的结果独立承担责任。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;5、人脸考勤技术对于您面容特征的采集、识别、验证、比对等均由您使用的手机、人脸考勤硬件设备及百度人脸识别完成。人脸考勤可用性取决于您手机及其他人脸考勤硬件设备中的人脸注册功能的可用性及机构系统的可用性。以下情形可能导致人脸识别功能工作不正常或不可用，从而导致人脸考勤功能不正常或不可用，小麦助教不承担任何责任：
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;(1)如果您的外观出现了显著的变化(如剃掉了络腮胡)，从而导致人脸考勤功能工作不正常或不可用；
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;(2)因受光线、角度、远近、佩戴眼镜/墨镜/帽子/围巾/口罩等面部遮挡、化妆/整容等脸型改变、眯眼、多人干扰、以及多次攻击等原因造成人脸考勤功能工作不正常或不可用；
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;(3)由于您的系统设置导致人脸考勤功能工作不正常或不可用；
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;(4)其他非小麦助教的原因导致人脸考勤功能工作不正常或不可用。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;6、小麦助教特别提醒您，基于现有人脸考勤技术的局限性，请您特别关注以下可能存在的风险：人脸考勤在特定人群中的安全性可能降低，这些人群包括双胞胎、和您长得很像的兄弟姐妹。如果您对上述风险及人脸考勤技术存有疑虑，建议您使用其他考勤方式。如由于上述风险及其他基于人脸考勤技术本身的局限性造成您的个人信息泄露或财产损失的，小麦助教不承担责任。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;7、小麦助教承诺并保证不会对您的人脸特征（或用户画像）作出包含淫秽、色情、赌博、迷信、恐怖、暴力等内容的描述，也不会作出对民族、种族、宗教、残疾、疾病歧视等内容的描述。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;8、未经您的授权，小麦助教不会将您的人脸特征用于本协议之外目的使用。同时，小麦助教会要求所有接触、收集、使用您的人脸特征的机构及个人按照本协议之目的使用人脸特征，并受本协议之约束。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;9、在您向小麦助教申请注销账户，或正式告知小麦助教删除您的个人信息时，小麦助教会在收到您的申请或通知后15个工作日能审核处理，过程中我们的客服可能会验证您的身份并为此向您收集必要的验证信息。处理完毕后，相关因验证而收集信息会即时删除，但会保留必要的操作记录及日志。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;10、小麦助教若停止或终止服务，会提前通过邮件、网站公告的形式通知您，并会在法律规定的合理的时间内删除您的人脸特征信息。
            <br />
            <h4>三、免责</h4>&nbsp;&nbsp;&nbsp;&nbsp;1、因下列原因导致小麦助教无法正常提供服务，小麦助教不承担责任：
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;(1)小麦助教系统停机维护或升级；
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;(2)因台风、地震、洪水、雷电或恐怖袭击等不可抗力原因；
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;(3)用户的软硬件和通信线路、供电线路出现故障的；
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;(4)用户操作不当或通过非小麦助教授权或认可的方式使用小麦助教服务的；
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;(5)因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、银行原因、第三方服务瑕疵或政府行为等原因。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;3、尽管有前条约定，小麦助教将采取合理行动积极促使服务恢复正常。
            <br />
            <h4>四、违约责任</h4>
            &nbsp;&nbsp;&nbsp;&nbsp;1、除本告知书另有约定外，小麦助教在提前邮件通知您或在网站公告的情况下，可以单方面暂停或终止向您提供人脸考勤服务。小麦助教在终止提供人脸考勤服务后，若发现您之前存在违法或违反本协议目的的使用行为，给小麦助教造成损失的，则小麦助教仍可据此要求您承担相应赔偿责任并保留通过司法途径予以解决的权利。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;2、如果小麦助教根据《人脸考勤服务告知书》或其他在您和小麦助教之间具有约束力的协议的约定，基于您的不当、违规或禁止行为对您的小麦助教账户暂停或终止提供小麦助教服务的，则人脸考勤服务将同时暂停或终止，该等暂停或终止不视为小麦助教的违约。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;3、因您违反本告知书或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，相关责任由您自行承担；小麦助教因此遭受损失的，您也应当一并赔偿，除非该等损失是由小麦助教的故意或者重大过失造成。
            <br />
            <h4>五、其他</h4>
            &nbsp;&nbsp;&nbsp;&nbsp;1、本《人脸考勤服务告知书》为《小麦助教服务协议》不可分割的一部分，小麦助教有权更新、修改本协议或公布新的内容，届时小麦助教会向您通知，若您继续使用本软件及本服务的，表示您已充分阅读、理解并接受更新、修改、新增部分内容；若您不同意，您将无法使用本服务。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;2、本告知书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国法律。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;3、若您和小麦助教之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您或小麦助教应当将纠纷或争议提交杭州杰竞科技有限公司住所地有管辖权的人民法院管辖。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;4、本告知书部分条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;5、本告知书未尽事宜，参照《小麦助教网站隐私协议》执行。
            <br />
            <br />
          </div>
        </div>
        <div className='ant-modal-footer footer'>
          <div>
            <button
              type='button'
              className='ant-btn ant-btn-primary'
              onClick={() => {
                handleOk();
              }}>
              <span>我知道了</span>
            </button>
          </div>
        </div>
        <style jsx>

        {`
            .layer_paperpage_content h2 {
              width: 100%;
              text-align: center;
              font-size: 24px;
              font-weight: 400;
              color: #333333;
              line-height: 22px;
              position: absolute;
              left: 0;
              top: 0;
            }
            .layer_paperpage_content .text_part {
              font-size: 14px;
              font-weight: 400;
              color: #666666;
            }
            .layer_paperpage_content h4 {
              margin: 0;
              margin: 8px 0;
              font-weight: 400;
              color: #333333;
              line-height: 22px;
              font-size: 16px;
            }

            .layer_parper_modal .ant-modal-body {
              max-height: 600px !important;
              height: 70vh !important;
              padding: 24px 0 !important;
              padding-bottom: 0px !important;
              overflow-y: hidden !important;
            }

            .layer_parper_modal .layer_paperpage {
              height: 100%;
              overflow-y: hidden;
              padding: 0px;
              height: 100%;
            }
            .layer_parper_modal .layer_paperpage .layer_paperpage_content {
              height: calc(100% - 49px);
              position: relative;
              overflow: auto;
              padding: 0 24px;
              padding-top: 33px;
            }
            .layer_parper_modal .footer {
              height: 49px;
              padding: 10px 16px;
              text-align: right;
              background: transparent;
              border-top: 1px solid #e8e8e8;
              border-radius: 0 0 4px 4px;
            }
          `}
        </style>
      </div>
    </Modal>
  );
});

export default LayerPaperPage;
